@if (shown) {
  <div
    class="datepicker"
    [class.with-time--]="time"
    (click)="handleOutsideClick($event)"
    @fadeAndScaleIn
    (@fadeAndScaleIn.start)="handleAnimationStart()"
    (@fadeAndScaleIn.done)="handleAnimationDone()"
    #root
    >
    <div class="datepicker__main" [class.single--]="singleDate">
      @if (!time) {
        <div class="datepicker__header">
          <ng-template
            #datefield
            let-label="label"
            let-targetDate="targetDate()"
            let-highlighted="highlighted()"
            let-clickable="clickable"
            >
            <div
              class="field   datepicker__field"
              [class.clickable--]="clickable"
              [class.highlighted--]="highlighted"
              >
              <div class="field__control   datepicker__field-control">
                <div class="datepicker__field-control-label">
                  {{ label }}
                </div>
                @if (targetDate) {
                  <span>
                    {{ targetDate | date: 'dd/MM/yyyy' }}
                  </span>
                }
              </div>
              <div class="field__block   datepicker__field-block">
                <span class="icon-font calendar--   field__icon"></span>
              </div>
              <div class="field__ui"></div>
            </div>
          </ng-template>
          @if (date) {
            <div class="datepicker__header-block">
              <ng-container *ngTemplateOutlet="datefield; context: singleDateFieldContext"></ng-container>
            </div>
          }
          @if (startDate && endDate) {
            <div class="datepicker__header-block">
              <button
                type="button"
                class="datepicker__field-container"
                (click)="changeTargetDate('startDate')"
                >
                <ng-container *ngTemplateOutlet="datefield; context: startDateFieldContext"></ng-container>
              </button>
            </div>
            <div class="datepicker__header-block">
              <button
                type="button"
                class="datepicker__field-container"
                (click)="changeTargetDate('endDate')"
                >
                <ng-container *ngTemplateOutlet="datefield; context: endDateFieldContext"></ng-container>
              </button>
            </div>
          }
        </div>
      }
      <div class="datepicker__body">
        @if (calendarView === 'years') {
          @for (yearData of yearsData; track yearData; let i = $index) {
            <div
              class="calendar"
              [class.mobile-active--]="i === mobileCalendarView "
              [class.with-time--]="time"
              >
              <div class="calendar__main-header">
                <div class="calendar__main-header-block start--">
                  @if (i === 1) {
                    <button
                      type="button"
                      class="calendar__main-header-item mobile-only-- for-single-calendar--"
                      (click)="previousMobileCalendarView()"
                      >
                      <span class="icon-font arrow-left--"></span>
                    </button>
                  }
                  @if (i === 0) {
                    <button
                      type="button"
                      class="calendar__main-header-item"
                      (click)="previousYearSet()"
                      >
                      <span class="icon-font arrow-left--"></span>
                    </button>
                  }
                </div>
                <div class="calendar__main-header-block mid--">
                  <div class="calendar__main-header-item">
                    {{ yearData[0] }} - {{ yearData[29] }}
                  </div>
                </div>
                <div class="calendar__main-header-block end--">
                  @if (i === 0) {
                    <button
                      type="button"
                      class="calendar__main-header-item mobile-only-- for-single-calendar--"
                      (click)="nextMobileCalendarView()"
                      >
                      <span class="icon-font arrow-right--"></span>
                    </button>
                  }
                  @if (i === yearsData.length - 1) {
                    <button
                      type="button"
                      class="calendar__main-header-item"
                      (click)="nextYearSet()"
                      >
                      <span class="icon-font arrow-right--"></span>
                    </button>
                  }
                </div>
              </div>
              <div class="calendar__years-body">
                <div class="calendar__years-body-inner">
                  @for (year of yearData; track year) {
                    <div
                      class="calendar__year-block"
                      [class.this-year--]="isToday(year)"
                      [class.alt-this-year--]="isAltToday(year)"
                      >
                      @if (yearIsBetweenMinAndMax(year)) {
                        <button
                          type="button"
                          class="calendar__year"
                          (click)="setTargetDateObj(year)"
                          >
                          {{ year }}
                        </button>
                      } @else {
                        <div class="calendar__year">
                          {{ year }}
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        }
        @if (calendarView === 'months') {
          @for (monthData of monthsData; track monthData; let i = $index) {
            <div
              class="calendar"
              [class.mobile-active--]="i === mobileCalendarView"
              [class.with-time--]="time"
              >
              <div class="calendar__main-header">
                <div class="calendar__main-header-block start--">
                  @if (i === 1) {
                    <button
                      type="button"
                      class="calendar__main-header-item mobile-only-- for-single-calendar--"
                      (click)="previousMobileCalendarView()"
                      >
                      <span class="icon-font arrow-left--"></span>
                    </button>
                  }
                  @if (i === 0) {
                    <button
                      type="button"
                      class="calendar__main-header-item"
                      (click)="previousYear()"
                      >
                      <span class="icon-font arrow-left--"></span>
                    </button>
                  }
                </div>
                <div class="calendar__main-header-block mid--">
                  <button
                    type="button"
                    class="calendar__main-header-item"
                    (click)="changeCalendarView('years')"
                    >
                    {{ monthData.year }}
                  </button>
                </div>
                <div class="calendar__main-header-block end--">
                  @if (i === 0) {
                    <button
                      type="button"
                      class="calendar__main-header-item mobile-only-- for-single-calendar--"
                      (click)="nextMobileCalendarView()"
                      >
                      <span class="icon-font arrow-right--"></span>
                    </button>
                  }
                  @if (i === monthsData.length - 1) {
                    <button
                      type="button"
                      class="calendar__main-header-item"
                      (click)="nextYear()"
                      >
                      <span class="icon-font arrow-right--"></span>
                    </button>
                  }
                </div>
              </div>
              <div class="calendar__months-body">
                <div class="calendar__months-body-inner">
                  @for (month of monthData.months; track month) {
                    <div
                      class="calendar__month-block"
                      [class.this-month--]="isToday(monthData.year, month.value)"
                      [class.alt-this-month--]="isAltToday(monthData.year, month.value)"
                      >
                      @if (monthIsBetweenMinAndMax(monthData.year, month.value)) {
                        <button
                          type="button"
                          class="calendar__month"
                          (click)="setTargetDateObj(monthData.year, month.value)"
                          >
                          {{ month.label }}
                        </button>
                      } @else {
                        <div class="calendar__month">
                          {{ month.label }}
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        }
        @if (calendarView === 'days') {
          @for (dayData of daysData; track dayData; let i = $index) {
            <div
              class="calendar"
              [class.mobile-active--]="i === mobileCalendarView"
              [class.with-time--]="time"
              >
              <div class="calendar__main-header">
                <div class="calendar__main-header-block start--">
                  @if (i === 1) {
                    <button
                      type="button"
                      class="calendar__main-header-item mobile-only-- for-single-calendar--"
                      (click)="previousMobileCalendarView()"
                      >
                      <span class="icon-font arrow-left--"></span>
                    </button>
                  }
                  @if (i === 0) {
                    <button
                      type="button"
                      class="calendar__main-header-item"
                      (click)="previousMonth()"
                      >
                      <span class="icon-font arrow-left--"></span>
                    </button>
                  }
                </div>
                <div class="calendar__main-header-block mid--">
                  <button
                    type="button"
                    class="calendar__main-header-item"
                    (click)="changeCalendarView('months')"
                    >
                    {{ dayData.dateObject | date: 'MMMM yyyy' }}
                  </button>
                </div>
                <div class="calendar__main-header-block end--">
                  @if (i === 0) {
                    <button
                      type="button"
                      class="calendar__main-header-item mobile-only-- for-single-calendar--"
                      [class.single--]="singleDate"
                      (click)="nextMobileCalendarView()"
                      >
                      <span class="icon-font arrow-right--"></span>
                    </button>
                  }
                  @if (i === daysData.length - 1) {
                    <button
                      type="button"
                      class="calendar__main-header-item"
                      (click)="nextMonth()"
                      >
                      <span class="icon-font arrow-right--"></span>
                    </button>
                  }
                </div>
              </div>
              <div class="calendar__days-header">
                <div class="calendar__day-block">
                  <div class="calendar__day">
                    M
                  </div>
                </div>
                <div class="calendar__day-block">
                  <div class="calendar__day">
                    T
                  </div>
                </div>
                <div class="calendar__day-block">
                  <div class="calendar__day">
                    W
                  </div>
                </div>
                <div class="calendar__day-block">
                  <div class="calendar__day">
                    T
                  </div>
                </div>
                <div class="calendar__day-block">
                  <div class="calendar__day">
                    F
                  </div>
                </div>
                <div class="calendar__day-block">
                  <div class="calendar__day">
                    S
                  </div>
                </div>
                <div class="calendar__day-block">
                  <div class="calendar__day">
                    S
                  </div>
                </div>
              </div>
              <div class="calendar__days-body">
                <div class="calendar__days-body-inner">
                  @for (day of dayData.days.previousMonth; track day) {
                    <div class="calendar__day-block">
                      <div class="calendar__day">
                        {{ day }}
                      </div>
                    </div>
                  }
                  @for (day of dayData.days.thisMonth; track day) {
                    <div
                      class="calendar__day-block"
                      [class.today--]="isToday(dayData.year, dayData.month, day)"
                      [class.alt-today--]="isAltToday(dayData.year, dayData.month, day)"
                      >
                      @if (dateIsBetweenMinAndMax(dayData.year, dayData.month, day)) {
                        <button
                          type="button"
                          class="calendar__day"
                          (click)="setDate(dayData.year, dayData.month, day)"
                          >
                          {{ day }}
                        </button>
                      } @else {
                        <div class="calendar__day">
                          {{ day }}
                        </div>
                      }
                    </div>
                  }
                  @for (day of dayData.days.nextMonth; track day) {
                    <div class="calendar__day-block">
                      <div class="calendar__day">
                        {{ day }}
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        }
        @if (time) {
          <div class="timepicker">
            <div class="timepicker__container">
              <div class="timepicker__block">
                <div class="timepicker__roller" #hourRoller>
                  <div class="timepicker__roller-container">
                    @for (hour of hours; track hour) {
                      <div class="timepicker__roller-item">
                        {{ hour }}
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="timepicker__block colon--">
                :
              </div>
              <div class="timepicker__block">
                <div class="timepicker__roller" #minuteRoller>
                  <div class="timepicker__roller-container">
                    @for (minute of minutes; track minute) {
                      <div class="timepicker__roller-item">
                        {{ minute }}
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="timepicker__block">
                <div class="timepicker__roller" #periodRoller>
                  <div class="timepicker__roller-container">
                    @for (period of periods; track period) {
                      <div class="timepicker__roller-item">
                        {{ period }}
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="datepicker__footer">
        <div class="datepicker__footer-block">
          <button type="button" class="link" (click)="cancel()">
            Cancel
          </button>
        </div>
        <div class="datepicker__footer-block">
          <button type="button" class="link" (click)="done()">
            Done
          </button>
        </div>
      </div>
    </div>
  </div>
}